import { CartResponse } from '../../types';
import { eventsRequest } from '../../utils/eventsRequest';
import { useAuth } from '../../contexts/AuthContext';

const getCart = async (): Promise<CartResponse | false> => {
    try {
        const response = await eventsRequest(`/cart`, 'get');

        if (response.status === 200) {
            return response.data as CartResponse;
        } else {
            if (response.status === 401) {
                const { sessionExpired } = useAuth();
                sessionExpired();
            }
            return false;
        }
    } catch (error) {
        return false;
    }
};

export default getCart;
